<template>
	<div class="item-wrapper">
		<div class="preview">
			<transition name="fade">
				<span class="title" v-if="addToCartChosenItem == item.id">Added</span>
			</transition>
			<img :src="imgDomain  + item.image_url" class="img"/>
		</div>
		<div class="left">
			<div class="title small name">{{item.title}}</div>
		</div>
		<div class="right">
			<button class="button" @click="$emit('addToCart',item, item.id)">BUY</button>
			<div class="price-container">
				<div class="price title small old-price">
					<span>{{item.old_price}}{{currency}}</span>
				</div>
				<div class="price title small">
					<span>{{item.price}} <span class="currency"> {{currency}}</span></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ProductCard',
	props: ['item', 'currency', 'addToCartChosenItem'],
	data: function() {
		return {
			imgDomain: ''
		}
	},
	mounted() {
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
	},
	methods: {
		
	},
}
</script>
